import './Logo.css';
import logo from '../../assets/images/fyf-logo.png';

const Logo = (props: { width: number }) => {
    const { width } = props;
    return <img alt='Find Your Fit Logo' src={logo} className='logo' style={{ width }} />;
};

export default Logo;
